import { RuleGroupType } from 'react-querybuilder';
import { EntityType } from './pageAction';

export type Entity = {
  id?: number;
  name?: string;
};

export class EntityClass implements Entity {
  id = 0;
  name = '';
}

export type EntityGroup = {
  id?: number;
  name?: string;
  entity_type?: EntityType;
  rules_name?: string;
  rules_schema?: RuleGroupType;
  rule_id?: number;
};

export type EntityGroupSearchParams = {
  name?: string;
  entity_type?: EntityType;
  skip?: number;
  limit?: number;
};

export class EntityGroupClass implements Entity {
  id = 0;
  name = '';
  entity_type = undefined;
  rule_id = 0;
}

export interface GetEntityByType {
  entity_type: string;
}
